import React from 'react';
import { Breadcrumb } from '../components/common/Breadcrumb';
import { StatusPanel } from '../components/integrations/StatusPanel';
import { DocumentApproval } from '../components/integrations/DocumentApproval';
import { AlertsPanel } from '../components/integrations/AlertsPanel';
import { IntegrationCard } from '../components/integrations/IntegrationCard';
const breadcrumbItems = [{
  label: 'Sistema',
  href: '#'
}, {
  label: 'Integraciones'
}];
export const Integrations = () => {
  return <div className="min-h-screen bg-gray-50" data-id="element-1441">
      <main className="pt-16 pl-64" data-id="element-1442">
        <div className="max-w-7xl mx-auto p-8" data-id="element-1443">
          <div className="mb-8" data-id="element-1444">
            <Breadcrumb items={breadcrumbItems} data-id="element-1445" />
            <h1 className="text-2xl font-bold text-gray-900 mt-4" data-id="element-1446">
              Estado del Sistema
            </h1>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8" data-id="element-1447">
            <StatusPanel data-id="element-1448" />
            <AlertsPanel data-id="element-1449" />
            <DocumentApproval data-id="element-1450" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1451">
            <IntegrationCard title="API Bancaria" status="active" lastSync="Hace 5 minutos" successRate={98.5} data-id="element-1452" />
            <IntegrationCard title="Firma Digital" status="warning" lastSync="Hace 1 hora" successRate={85.2} data-id="element-1453" />
            <IntegrationCard title="Sistema de Pagos" status="active" lastSync="Hace 2 minutos" successRate={99.1} data-id="element-1454" />
            <IntegrationCard title="Validación de Documentos" status="error" lastSync="Hace 3 horas" successRate={45.8} data-id="element-1455" />
            <IntegrationCard title="Notificaciones SMS" status="active" lastSync="Hace 8 minutos" successRate={97.3} data-id="element-1456" />
            <IntegrationCard title="Verificación de Identidad" status="warning" lastSync="Hace 30 minutos" successRate={89.9} data-id="element-1457" />
          </div>
        </div>
      </main>
    </div>;
};